// components/session-sync.tsx
"use client";

import { ExtendedUserWithProfile } from "@/lib/types";
import useAppSettings from "@/store/appSettings";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

export const SessionSync = () => {
  const { data: session, update } = useSession();
  const { setUser, user } = useAppSettings();

  useEffect(() => {
    // If there is an active session, sync it to Zustand
    if (session?.user) {
      // Check if Zustand is stale (e.g. session has empNo but Zustand doesn't)
      const sessionUser = session.user as ExtendedUserWithProfile;

      // NextAuth's session object never carries `.profile` (that only comes
      // from the server-rendered layout's DB fetch) — comparing/replacing the
      // whole object here would permanently wipe it out on every session
      // refresh, which is exactly why the topbar's localized name kept
      // reverting to the flat English `user.name`. Only sync the scalar
      // fields the session can actually change, and always keep whatever
      // profile the store already has.
      const needsSync =
        user?.empNo !== sessionUser.empNo ||
        user?.role !== sessionUser.role ||
        user?.image !== sessionUser.image ||
        user?.name !== sessionUser.name ||
        user?.email !== sessionUser.email;

      if (needsSync) {
        console.log("🔄 Syncing fresh session data to Zustand...");
        setUser({ ...user, ...sessionUser, profile: user?.profile } as ExtendedUserWithProfile);
      }
    }
  }, [session, setUser, user]);

  return null; // This component renders nothing
};
